import React, {useMemo} from 'react';

import {useCategory} from 'coreHooks/categories';

import ContentCard from 'brandComponents/ContentCard';

import {EContentCardStyle} from '../../IContentCardContentful';

import {IContentCardRendererProps} from './IContentCardRenderer';

const ContentCardRenderer = (props: IContentCardRendererProps) => {
	const targetObj = props?.target?.props || props?.target;
	const category = useCategory(targetObj?.targetCategory);

	const targetUrl = useMemo(() => {
		return category?.getUrl() || targetObj?.targetUrl || targetObj?.targetPage?.slug;
	}, [category, targetObj?.targetUrl, targetObj?.targetPage?.slug]);

	return (
		<ContentCard link={targetUrl} classNames={props?.classNames} style={EContentCardStyle[props?.style]}>
			{!!props.imagesCollection?.items?.length && (
				<ContentCard.Images>{props.imagesCollection.reactElements}</ContentCard.Images>
			)}

			<ContentCard.InnerWrapper>
				{!!props.subtitlesCollection?.items?.length && (
					<ContentCard.Subtitles>
						{props.subtitlesCollection.reactElements}
					</ContentCard.Subtitles>
				)}

				<ContentCard.Title>
					{props.title}
				</ContentCard.Title>

				{!!props.description && (
					<ContentCard.Description>
						{props.description}
					</ContentCard.Description>
				)}

				{!!props.linksCollection?.items?.length && (
					<ContentCard.Links>{props.linksCollection.reactElements}</ContentCard.Links>
				)}
			</ContentCard.InnerWrapper>
		</ContentCard>
	);
};

export default ContentCardRenderer;
